import React from "react";
import util from 'lodash/util';

import Webcam from './react-webcam';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({

    root: {
        position: 'absolute',
        backgroundColor: theme.palette.mediaDisplay.main,
        color: theme.palette.mediaDisplay.contrastText,
        overflow: 'hidden',
        align: 'auto',

        [theme.breakpoints.up('sm')] : {
            width: '50%',
            height: '75%',
            top: '5%',
            left: '25%',
            boxShadow: theme.shadows[5],
        },
        [theme.breakpoints.down('xs')] : {
            width: '100%',
            height: '100%',
        },

    },

    videoPreview: {
        //display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',

    },

    dismissButton : {
        position: 'absolute',
        top: 8,
        left: 8,
    },

    captureButton: {
        backgroundColor: 'transparent',
        position: 'absolute',
        width: 100,
        height: 100,
        bottom: 44,
        left: '50%',
        transform: 'translate(-50%, 0)',
    },

    captureButtonInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },

    imageReview: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },

    image: {
        position: 'absolute',        
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },

    acceptButton: {
        position: 'absolute',
        right: 8,
        top: 8,
        //borderColor: theme.palette.mediaDisplay.contrastText,
    },

    retakeButton: {
        position: 'absolute',
        left: 8,
        top: 8,
        borderColor: theme.palette.mediaDisplay.contrastText,
    },
});

class Camera extends React.Component {

    constructor(props) {
        super(props);
        this.state = { imageSrc: null }
    }

    setWebcamRef = (webcam) => {
        this.webcam = webcam;
    }

    capture = () => {
        const imageSrc = this.webcam.getScreenshot();
        if (!!imageSrc) {
            this.setState({imageSrc: imageSrc});
        }
    }

    removeImage = () => {
        this.setState({imageSrc: null});
    }

    render() {

        const { onCapture, onClose, classes } = this.props;

        return (
            <div className={classes.root}>
                <Webcam
                    className={classes.videoPreview}
                    width={1920}
                    height={1080}
                    facingMode={'user'}
                    audio={false}
                    screenshotFormat={'image/jpeg'}
                    ref={this.setWebcamRef}
                />
                <div className={classes.captureButton}>
                    <svg>
                        <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="4" fill='rgba(255, 149, 0, 0.3)' />
                    </svg>
                    <IconButton className={classes.captureButtonInner} color='inherit' aria-label='Capture' onClick={this.capture}>
                        <PhotoCamera />
                    </IconButton>
                </div>

                <IconButton className={classes.dismissButton} color='inherit' aria-label='Dismiss' onClick={onClose}>
                    <CloseIcon />
                </IconButton>
                {!!this.state.imageSrc &&
                    <div className={classes.imageReview}>
                        <img className={classes.image} src={this.state.imageSrc} alt={'candidate profile'}/>
                        <Button variant='outlined' color='primary' onClick={this.removeImage} className={classes.retakeButton}>Retake</Button>
                        <Button variant='raised' color='primary' onClick={() => onCapture(this.state.imageSrc)} className={classes.acceptButton} >Accept</Button>
                    </div>
                }
            </div >
        )
    }
}

var enhance = util.flowRight(
    withStyles(styles),
    withWidth(),
  );

export default enhance(Camera);


// WEBPACK FOOTER //
// ./src/Components/Camera.js